import React from 'react';
import { ZoomIn, ZoomOut } from 'lucide-react';
import './TextSizeStepper.css';

/**
 * TextSizeStepper — the app-wide text-size control (#181).
 *
 * Decision (Joel, 2026-06-12): every text-size control is the A−/A+
 * stepper pattern from #177 — 44px targets, disabled at bounds,
 * aria-labels, no hover-only behavior. One modality everywhere.
 *
 * Control-form only: each surface keeps its own range, step, state,
 * and persistence key — this component just renders the buttons and
 * clamps.
 *
 * @param {number} value - Current size (surface's own units, e.g. %)
 * @param {function} onChange - Called with the clamped next value
 * @param {number} min
 * @param {number} max
 * @param {number} step
 * @param {string} [label='Text size'] - Group aria-label
 */
export function TextSizeStepper({ value, onChange, min, max, step, label = 'Text size' }) {
  const stepTo = (direction) =>
    onChange(Math.min(max, Math.max(min, value + direction * step)));

  return (
    <div className="text-size-stepper" role="group" aria-label={label} title={`${label}: ${value}%`}>
      <button
        type="button"
        className="text-size-stepper__btn"
        onClick={() => stepTo(-1)}
        disabled={value <= min}
        aria-label="Smaller text"
      >
        <ZoomOut size={18} />
      </button>
      <button
        type="button"
        className="text-size-stepper__btn"
        onClick={() => stepTo(1)}
        disabled={value >= max}
        aria-label="Larger text"
      >
        <ZoomIn size={18} />
      </button>
    </div>
  );
}

export default TextSizeStepper;
